module.exports = __webpack_public_path__ + "img/summer-pudding.21a99ce5.jpg";